<script setup lang="ts">
import { CardAdmin } from '@shared/ui/cards'

import HelpersGrid from './HelpersGrid.vue'
import HelperActionRow from './HelperActionRow.vue'

defineOptions({
  name: 'HelpersBookingsPage',
})
</script>

<template>
  <HelpersGrid>
    <CardAdmin
      title="Booking"
      fullwidth
    >
      <HelperActionRow
        label="Delete upcoming reserved lessons (one day)"
        route-name="admin.helpers.bookings.delete-upcoming-reserved-lessons"
      />
    </CardAdmin>
    <CardAdmin
      title="Recordings"
      fullwidth
    >
      <HelperActionRow
        label="Retrieve recordings"
        route-name="admin.helpers.recordings.retrieve"
      />
    </CardAdmin>
  </HelpersGrid>
</template>
